import React from 'react';
import AnimatedCounter from './AnimatedCounter';

function App() {
    return (
        <div>
            <AnimatedCounter
                countTo={100}
            />
        </div>
    );
}

export default App;